<template>
  <NavBar
    :app-title="title"
    :page-title="$route.meta.title as string"
    :apps="useAuth().session.value.applications"
    :session="useAuth().session.value"
    @sign-out="useAuth().signOut"
  />

  <div class="main-app d-flex h-screen">
    <NavDrawer />

    <div class="w-100 overflow-y-auto">
      <router-view v-slot="{ Component }">
        <Transition :mode="'out-in'" :appear="true">
          <Suspense>
            <v-main class="overflow-y-auto pa-8 h-100">
              <component :is="Component" />
            </v-main>

            <template #fallback>
              <v-progress-circular />
            </template>
          </Suspense>
        </Transition>
      </router-view>
    </div>
  </div>
</template>

<script setup lang="ts">
import NavDrawer from '@/components/NavDrawer.vue'
import { useAuth } from '@simplifi/auth'
import { NavBar } from '@simplifi/components'

const title = import.meta.env.VITE_APP_TITLE
</script>
